<i18n>
{
  "en": {
    "methodics": {
      "title": "methodics"
    }
  }
}
</i18n>

<template>
  <div class="extension">
    <h1>{{ $t('methodics.title') }}</h1>
    <router-view />
  </div>
</template>


<script>
export default {
  name: 'methodics',
};
</script>
